import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from 'src/app/helpers/string-helper';

@Pipe({
  name: 'displayIPBoardAssociation'
})
export class DisplayIPBoardAssociationPipe implements PipeTransform {
  transform(
    defaultValue: string,
    adjustmentValue: string,
    otherValue: string,
    fallback: string
  ) {
    return !StringHelper.isEmpty(adjustmentValue)
      ? adjustmentValue
      : !StringHelper.isEmpty(otherValue)
      ? otherValue
      : !StringHelper.isEmpty(defaultValue)
      ? defaultValue
      : fallback;
  }
}
